import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-1 overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col w-full p-0 divide-y divide-divider" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "min-h-11 min-w-11 bg-white rounded-full flex items-center justify-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { useI18n } from "vue-i18n";
import { menuItems } from "@/constants/menu";
import { ref, watch } from "vue";
import { MenuItem } from "@/types/menuItem";
import { useRoute, useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import lockedIcon from "@/assets/icons/locked.svg";
import { useUserStore } from "@/stores/userStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorSidebarItems',
  emits: ["closeMenu"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const selectedCalculator = ref<MenuItem | null>(null);

const emits = __emit;

watch(
  () => route.name as (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES],
  (newRouteName) => {
    if (!newRouteName) return;

    const current = menuItems.find(
      (item) =>
        item.menuName === newRouteName ||
        item.matchNames?.includes(newRouteName)
    );
    selectedCalculator.value = current ?? null;
  },
  { immediate: true }
);

function isMenuLocked(menuItem: MenuItem) {
  return (
    menuItem.premiumType !== undefined &&
    !userStore.userHasSubscription(menuItem.premiumType)
  );
}

function openCalculator(menuItem: MenuItem) {
  if (
    menuItem.premiumType !== undefined &&
    !userStore.userHasSubscription(menuItem.premiumType)
  ) {
    let query = {};
    if (userStore.user !== null) {
      query = { openCalculator: menuItem.premiumType };
    }
    router.push({ name: ROUTE_NAMES.USER, query: query });
    return;
  }
  selectedCalculator.value = menuItem;
  if (menuItem.menuName !== null) {
    router.push({ name: menuItem.menuName });
    emits("closeMenu");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item.key,
          class: _normalizeClass(["group flex gap-x-4 items-center justify-between px-4 py-[12px] h-[60px] transition-colors", 
          selectedCalculator.value?.key === item.key
            ? 'bg-brown text-white'
            : 'hover:bg-hover text-brown cursor-pointer'
        ]),
          onClick: ($event: any) => (
          selectedCalculator.value?.key === item.key ? null : openCalculator(item)
        )
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: item.icon,
                alt: "",
                class: "size-8"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["sf-pro-sm text-left transition-colors whitespace-pre-line", 
              selectedCalculator.value?.key !== item.key
                ? 'group-hover:text-active'
                : ''
            ])
            }, _toDisplayString(_unref(t)(item.key)), 3)
          ]),
          (isMenuLocked(item))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(lockedIcon),
                alt: "locked",
                class: "size-5"
              }, null, 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["transform transition-transform duration-300 ease-in-out", 
            selectedCalculator.value?.key !== item.key
              ? 'text-active  group-hover:rotate-45'
              : 'text-white opacity-35 rotate-45'
          ])
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "min-w-[10px] min-h-[10px] max-w-[10px] max-h-[10px]"
                }, [
                  _createElementVNode("path", {
                    d: "M1 11L11 1M11 1H1M11 1V11",
                    stroke: "currentColor",
                    "stroke-width": "1.6",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))], 2))
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})